import React from 'react'

const EnergyComponent = ({title, image, desc}) => {
  return <div className="w-full bg-[#2928AF] shadow-md shadow-gray-400 p-[10px] rounded-[17px]">
    <img alt='voltage' src={`/images/${image}.png`}/>
    <h1 className='text-center text-[24px] font-medium italic text-white'>{title}</h1>
    <p className='mt-[8px] text-[10px] font-semibold text-white text-center'>{desc}</p>
  </div>
}

export default EnergyComponent